/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "../../../utils/leadsWebEnviroment";

interface EmailProps {
  email: string | null;
  emailPrincipal: boolean;
  codigoCampoEmail: number;
}

interface BodyProps {
  emails: EmailProps[];
  idLead: string;
}

interface Params {
  idLeadCorretor: string;
  body: BodyProps;
}

export function useAlterarEmails(props: Params) {
  const registerData = async () => {
    const ALTERAR_EMAILS = `${leadsWebEnviroment}/commom/leads/alterar-emails/v1/${props?.idLeadCorretor}`;
    return await instance.put(ALTERAR_EMAILS, props?.body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["alterar_emails"],
    onSuccess: () => {
      toast.success("Emails alterados com sucesso", {
        autoClose: 10000,
      });
    },
    onError: (error: any) => {
      const errorMessages = error.response.data.notifications.map(
        (item: any) => `\n${item?.message}\n`
      );

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
